export default "__VITE_ASSET__QO5B1WTf__"